<template>
  <header class="specialHeader">
    <div class="specialLogo">
      <img src="@/images/mize_w.png" alt="mizeLogo" class="specialLogoImg" />
    </div>
    <div class="specialUserArea">
      <!-- 내정보 -->
      <div class="specialUserInfo">
        <div class="specialUserImg">          
          <img :src="currentUserPhoto || defaultProfileImg" alt="userProfileImg">  
        </div>
        <div class="specialUserDes">
          <div class="specialUserName" @click="selectMyInfo()">{{ username }}</div>
          <div class="specialUserVacation">휴가/연차 : 25.25일</div>
        </div>
      </div>
      <!-- 알람 -->
      <div class="specialAlert" @click="showAlarmPopup = !showAlarmPopup">
        <span class="specialAlertBox">
          <i class="specialBi bi-bell"></i>
          <i class="specialBi alertNum">{{ unreadCount }}</i>
        </span>
      </div>
      <!-- 로그아웃 버튼 -->
      <div class="specialLogout">
        <span class="specialLogoutBox" @click.prevent="logout">
          <i class="specialBi bi-door-open"></i>
        </span>
      </div>
    </div>
  </header>
  
  <!-- 알람창 -->
  <div class="specialModalPage specialAlertPage" v-show="showAlarmPopup">
    <div class="specialAlertPageHeader">
      <h5>알림</h5>
      <div class="specialModalHeaderBtnBox">
        <span class="closeBtn" @click="showAlarmPopup = false"><i class="bi bi-x-lg"></i></span>
      </div>
    </div>
    <div class="specialModalBody">
      <div class="specialModalBodyHeader">
        <div class="specialModalBodyHeaderMenu">
          <div class="specialAlertMenu">
            <div id="specialAlertUnconfirmed" class="specialAlertMenuItem" :class="{ active: selectedAlertTab === 'N' }" @click="selectedAlertTab = 'N'; fetchNotifications(true)">미확인</div>
            <div id="specialAlertAll" class="specialAlertMenuItem" :class="{ active: selectedAlertTab === 'A' }" @click="selectedAlertTab = 'A'; fetchNotifications(true)">전체</div>
          </div>
          <div class="specialAlertMenu">
            <div class="specialAlertMenuItem" @click="isReadUpdate()">모두읽음</div>
          </div>
        </div>
        <div class="specialModalBodyHeaderFilterBox">
          <!-- specialModalBodyHeaderSearch active될 시 사라짐 / 취소 누르면 나타남 (.active) -->
          <div class="specialModalBodyHeaderFilter active">
            <div class="specialAlertFilter">
              <!-- 선택시 active 클래스 추가 -->
              <div class="specialAlertFilterItem" @click="showAlert();">나를 언급</div>
              <div class="specialAlertFilterItem active" @click="showAlert();">내 게시물</div>
              <div class="specialAlertFilterItem" @click="showAlert();">담당 업무</div>
            </div>
            <div class="specialAlertFilterSearchBtn specialAlertFilterItem" @click="showAlert();">
              <i class="bi bi-search "></i>
            </div>
          </div>
          <!-- specialAlertFilterSearchBtn 버튼 클릭시 나타남 (.active) / 취소 클릭시 사라짐 -->
          <div class="specialModalBodyHeaderSearch">
            <div class="specialAlertFilterSearch">
              <input type="search" placeholder="검색어를 입력하세요.">
              <div class="specialAlertFilterItem noBorder">취소</div>
            </div>
          </div>
        </div>
      </div>
      <div class="specialModalBodyList" ref="notificationContainer">
        <ul v-if="notifications.length > 0">
          <li
            v-for="(notification, index) in notifications"
            :key="index"
            class="specialAlertItem" :class="{ unconfirmed: notification.isRead === 'N' }"
            @click="
              !notification.commentId
                ? null
                : handleNotificationClick(
                    notification.id,
                    notification.commentId,
                    notification.readId,
                    notification.leftMenuName
                  )
            "
          >
            <div class="specialAlertItemImg">
              <img
                :src="
                  notification.userPhotoName
                    ? `https://mizecloud-partners.co.kr/employee_img/${notification.userPhotoName}`
                    : 'https://mizecloud-partners.co.kr/employee_img/default.png'
                "
                alt="profileImg"
              />
            </div>
            <div class="specialAlertItemDes">
              <div class="specialAlertTop">
                <div class="specialAlertName">{{ notification.userName }}</div>
                <div class="specialAlertTime">{{ notification.createdDtm }}</div>
              </div>
              <div class="specialAlertMiddle">
                <template v-if="notification.parentId">
                  <b>댓글에 댓글</b>을 남겼습니다.
                </template>
                <template v-else>
                  게시물에 <b>댓글</b>을 남겼습니다.
                </template>
              </div>
              <div class="specialAlertBottom">
                <div class="specialAlertTitle">
                  {{ notification.commentSubject }} 
                </div>
                <div class="specialAlertDes">
                  ↳ '{{ notification.commentContent }}'
                </div>
              </div>
            </div>
          </li>
        </ul>
        
      </div>
    </div>
  </div>

</template>

<script>
import apiClient from "@/apiClient"; // 설정 파일에서 가져온 axios 인스턴스
import { useToast } from "vue-toastification";
import eventBus from '@/eventBus';

export default {
  data() {
    return {
      showNotifications: false, // 알림 드롭다운 표시 여부
      notifications: [], // 알림 데이터
      unreadCount: 0, // 읽지 않은 알림 개수
      alarmList: [], // 추가된 공지사항 데이터를 저장
      prevLeftMenus: [],
      showAlarmPopup: false,
      selectedAlertTab: 'A', // A:전체알림 / N:미확인알림
      hasMore: true,
      isLoading: false,
      currentPage: 1,
      currentUserPhoto: "https://mizecloud-partners.co.kr/employee_img/" + localStorage.getItem("userphoto"), // 현재 사용자 프로필 이미지
      defaultProfileImg: "https://mizecloud-partners.co.kr/employee_img/default.png"
    };
  },
  name: "SpecialMainHeader",
  setup() {
    const toast = useToast();
    return { toast };
  },
  computed: {
    username() {
      return this.$store.getters.getUsername;
    },
    userType() {
      return this.$store.getters.getUsertype;
    },
    userModeAuthority() {
      return this.$store.getters.getUserModeAuthority;
    },
    selectedMenu() {
      return this.$store.getters.getSelectedMenu;
    },
    topMenus() {
      return Array.isArray(this.$store.state.topMenus) ? this.$store.state.topMenus : [];
    }
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
    eventBus.off("user-info-updated", this.getTopMenu);
    eventBus.off("user-info-updated", this.getLeftMenu);

    const container = this.$refs.notificationContainer;
    if (container) {
      container.removeEventListener('scroll', this.onScroll);
    }
  },
  async mounted() {
    this.fetchNotifications(true);

    this.$nextTick(() => {
      const container = this.$refs.notificationContainer;      
      if (container) {
        container.addEventListener('scroll', this.onScroll);
      }
    });
    
    const token_userid = localStorage.getItem("userid");

    if (token_userid) {
      const user = {
        UserId: token_userid,
      };

      // API 호출
      if (user.UserId) {
        try {
          const response = await apiClient.post("/api/User/user-my-info", user);

          if (response.status === 200) {
            const userName = response.data.user.AdminName;
            const usertype = response.data.user.UserType;
            const userModeAuthority = response.data.user.ModeAuthority;
            const userPhoto = response.data.user.UserPhoto;

            this.$store.dispatch("updateUserName", userName); // Vuex 스토어와 localStorage에 저장
            this.$store.dispatch("updateUserType", usertype); // Vuex 스토어와 localStorage에 저장
            this.$store.dispatch("updateUsermodeauthority", userModeAuthority); // Vuex 스토어와 localStorage에 저장
            this.$store.dispatch("updateUserPhoto", userPhoto); // Vuex 스토어와 localStorage에 저장
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
    } else {
      this.$router.push({ path: "/" });
    }

    document.addEventListener("click", this.handleOutsideClick);

    if (this.$store.state.menuMode === '') {
      if (this.userModeAuthority === 'A')
        this.$store.state.menuMode = this.$store.state.menuMode === 'M' ? 'C' : 'M';
      else
        this.$store.state.menuMode = this.userType === 'M' ? 'M' : 'C';
    }
  },
  methods: {
    logout() {
      if (confirm("로그아웃 하시겠습니까?")) {
        this.toast.success("로그아웃 되었습니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        localStorage.clear();
        this.$store.dispatch("updateUserName", ""); // Vuex 스토어에서 사용자 이름 제거
        this.$store.dispatch("updateUserType", ""); // Vuex 스토어에서 사용자 이름 제거
        this.$store.dispatch("updateUsermodeauthority", ""); // Vuex 스토어와 localStorage에 저장
        this.$store.commit('setMenuMode', '');
        this.$store.commit('setRefreshFlag', false);        
        this.$store.commit('setSelectedMenu', '');
        this.$store.commit('setAllMenus', '');
        this.$store.commit('setTopMenus', []);
        this.$store.commit('setLeftMenus', []);
        this.$router.push({ path: "/" });
      }
    },
    showAlert() {
      alert('준비중입니다.');
      return;
    },
    onScroll(e) {
      const el = e.target;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 30;

      if (nearBottom) {
        this.fetchNotifications();
      }
    },
    setAlertTab(tab) {
      this.selectedAlertTab = tab;
      this.fetchNotifications();
    },
    async isReadUpdate() {
      try {
        const searchParam = {
          LoginUserId: localStorage.getItem("userid")
        };
        
        const response = await apiClient.post("/api/Alarm/alarm-all-read-update", searchParam);

        if (response.status === 200) {
          this.toast.success('모든 알림이 읽음처리되었습니다.', {
            position: "top-center", // 메시지 위치
            timeout: 1500, // 3초 동안 표시
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: true, // 진행 표시줄 숨기기
            closeButton: false, // X 버튼 숨기기
          });

          this.fetchNotifications(true);
        }
      } catch (error) {
        console.error("Error fetching all alarm read update:", error);
      }
    },
    async fetchNotifications(isInit = false) {
      if (this.isLoading || (!this.hasMore && !isInit)) return;

      if (isInit) {
        this.currentPage = 1;
        this.notifications = [];
        this.hasMore = true;
      }

      this.isLoading = true;

      try {
        const searchParam = {
          Page: this.currentPage,
          PageSize: 6, // 알림 목록에서 가져올 항목 수 제한
          SearchConfirmStatus: this.selectedAlertTab, // 확인 여부 (A:전체 / N:미확인)
          SearchStatus: "A", // 전체 카테고리
          SearchBoardStatus: "", // 게시판 전체
          SearchEmployeeStatus: "A", // 모든 직원
          LoginUserId: localStorage.getItem("userid"),
          SearchUserId: "All",
        };
        
        const response = await apiClient.post(
          "/api/Alarm/all-alarm-list",
          searchParam
        );

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          const newList = Array.isArray(data.data) ? data.data : [];

          if (isInit) {
            this.notifications = newList;
          } else {
            this.notifications.push(...newList);
          }

          this.isLoading = false;
          this.hasMore = newList.length === 6;
          this.unreadCount = data.meta.totalCount || 0;

          if (newList.length > 0) {
            this.currentPage += 1;
          }
        }
      } catch (error) {
        console.error("Error fetching alarm notifications:", error);
      }
    },
    handleNotificationClick(postId, commentId, readId, leftMenuName) {
      if (!postId) {
        console.error("Post ID가 없습니다.");
        return;
      }
      // 1. 읽음 처리
      this.handleNotificationAction(readId).then(() => {
        this.autoSetTopLeftMenu(leftMenuName);
        if (leftMenuName === "프로젝트목록 (마이즈)") {
          this.$router.push({
            path: `/projects/mizeview/${postId}`,
            query: { commentId },
          });
        }

        if (leftMenuName === "프로젝트목록 (외주)") {
          this.$router.push({
            path: `/projects/view/${postId}`,
            query: { commentId },
          });
        }

        if (leftMenuName === "담당자목록") {
          this.$router.push({
            path: `/managers/view/${postId}`,
            query: { commentId },
          });
        }

        if (leftMenuName === "직원목록") {
          this.$router.push({
            path: `/employee/view/${postId}`,
            query: { commentId },
          });
        }

        if (leftMenuName === "공지사항목록") {
          this.$router.push({
            path: `/notices/view/${postId}`,
            query: { commentId },
          });
        }

        // 3. 페이지 로드 후 스크롤 처리
        this.$nextTick(() => {
          setTimeout(() => {
            const commentElement = document.getElementById(
              `comment-${commentId}`
            );
            if (commentElement) {
              commentElement.scrollIntoView({ behavior: "smooth" });
            }
          }, 500);
        });
      });
    },    
    // 알림 읽음 및 제거 처리
    async handleNotificationAction(notificationId) {
      try {
        const searchParam = {
          Page: 1,
          PageSize: 100,
          SearchConfirmStatus: this.selectedAlertTab, // 확인 여부 (A:전체 / N:미확인)
          SearchStatus: "A", // 전체 카테고리
          SearchBoardStatus: "", // 게시판 전체
          SearchEmployeeStatus: "A", // 모든 직원
          LoginUserId: localStorage.getItem("userid"),
          SearchUserId: "All",
          ReadId: notificationId,
        };

        const response = await apiClient.post(
          "/api/Alarm/all-alarm-list",
          searchParam
        );
        
        if (response.status === 200) {
          // 읽지 않은 알림 개수 감소
          this.unreadCount = Math.max(this.unreadCount - 1, 0);
        }
      } catch (error) {
        console.error(
          "Error marking notification as read and removing:",
          error
        );
      }
    },
    selectMyInfo() {
      this.$store.commit('setSelectedMenu', '내 정보');
      this.$store.commit('setSelectedMenuId', 0);
      this.$router.replace({ path: "/temp-route" }).then(() => {
        this.$router.replace('/myinfo/view');
      });
    },
    async autoSetTopLeftMenu(leftMenuName) {
      this.$store.commit('setTopMenus', []);
      this.$store.commit('setLeftMenus', []);

      const keywordMap = [
        { keyword: '프로젝트', name: '프로젝트목록', changemode: 'C'},
        { keyword: '정산', name: '정산목록', changemode: 'C' },
        { keyword: '담당자', name: '담당자목록', changemode: 'C' },
        { keyword: '직원', name: '직원목록', changemode: 'M' },
        { keyword: '공지사항', name: '공지사항목록', changemode: 'C' }
      ];

      let matchedKeyword = keywordMap.find(item => leftMenuName.includes(item.name));
      let targetTopMenuId = null;
      let targetMenuName = null;

      this.$store.commit('setMenuMode', matchedKeyword.changemode);
      await this.getTopMenu(this.$store.state.menuMode);

      if (matchedKeyword) {
        const menu = this.$store.state.topMenus.find(m => m.menuName.includes(matchedKeyword.keyword));
        if (menu) {
          targetTopMenuId = menu.topMenuId;
          targetMenuName = menu.menuName;
        }
      }
      
      this.$store.commit('setSelectedMenu', targetMenuName);
      this.$store.commit('setSelectedMenuId', targetTopMenuId); 
    },
    async getTopMenu(menuMode = this.$store.state.menuMode) {
      if (this.$store.state.topMenus.length > 0) return;
      
      try {
          const user = {
            LoginUserId: localStorage.getItem("userid"),
            UserType: localStorage.getItem("usertype"),
            MenuMode: menuMode
          };

          const response = await apiClient.post("/api/Menu/top-menu-list", user);

          if (response.status === 200) {               
            this.$store.commit("setTopMenus", JSON.parse(response.data).data);
            this.setSelectedTopMenuByRoute();
            this.getLeftMenu();
          }
        } catch (error) {
          console.error("Error fetching top menu data:", error);
        }
    },
    async getLeftMenu() {   
      if (this.$store.state.leftMenus.length > 0) return;
 
      try {
          const user = {
            LoginUserId: localStorage.getItem("userid"),
            UserType: localStorage.getItem("usertype"),
            TopMenuId: this.$store.state.selectedMenuId,
            MenuMode: this.$store.state.menuMode
          };

          const response = await apiClient.post("/api/Menu/left-menu-list", user);

          if (response.status === 200) {            
            const originData =  JSON.parse(response.data).data;
            const addMyinfoData = {
              id: 0,
              topMenuId: 0,
              leftMenuId: 0,
              menuName: "내 정보 수정",
              menuDomain: "https://mizecloud-partners.co.kr",
              menuLink: "/myinfo/view"
            }
            const addNotiData = {
              id: 0,
              topMenuId: -1,
              leftMenuId: 0,
              menuName: "알림목록",
              menuDomain: "https://mizecloud-partners.co.kr",
              menuLink: "/alarmsnotices/list"
            }
            
            let mergedData = [...originData, addMyinfoData, addNotiData, ...this.prevLeftMenus];
            const filteredData = mergedData.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.menuLink === item.menuLink)
            );

            mergedData = filteredData;
            this.$store.commit("setLeftMenus", mergedData);   
          }
        } catch (error) {
          console.error("Error fetching left menu data:", error);
        }
    },    
    setSelectedTopMenuByRoute() {
      const currentPath = this.$route.path;
      const matchedMenu = this.topMenus.find(menu => {
        return menu.menuLink && menu.menuLink === currentPath;
      });
      
      if (matchedMenu) {        
        this.$store.commit('setSelectedMenuId', matchedMenu.topMenuId);
      }
    },
  }
};


</script>

